<template>
    <div id="credit-score-half-meter" class="transition-transform flex justify-center" :title="showOutdatedWarning ? '60+ days passed, please update your credit score' : ''">
        <svg viewBox="-48 -48 398 316" class="w-full h-auto" fill="none"
             xmlns="http://www.w3.org/2000/svg">
            <path
                d="M19.0311 218.479C17.5502 219.23 15.7375 218.64 15.0159 217.146C3.60151 193.52 -1.45799 167.313 0.362516 141.108C2.25248 113.905 11.4864 87.7209 27.0829 65.3395C42.6795 42.9583 64.0559 25.2159 88.9399 13.9984C112.909 3.19291 139.272 -1.16946 165.417 1.31731C167.071 1.47454 168.254 2.9675 168.063 4.61529L167.021 13.6405C166.83 15.2883 165.339 16.4665 163.685 16.313C140.252 14.1365 116.636 18.0704 95.1554 27.7541C72.7597 37.8499 53.521 53.8181 39.4841 73.9613C25.4473 94.1044 17.1368 117.67 15.4358 142.153C13.8042 165.637 18.3123 189.124 28.4934 210.316C29.2117 211.812 28.6236 213.618 27.1427 214.369L19.0311 218.479Z"
                fill="#EF4444" />
            <path
                d="M169.617 4.64112C169.826 2.99573 171.333 1.82879 172.976 2.07101C203.888 6.62979 232.628 20.6512 255.23 42.2013C256.432 43.3466 256.436 45.2506 255.266 46.4275L248.856 52.8733C247.686 54.05 245.784 54.0537 244.58 52.9111C224.344 33.7023 198.676 21.1791 171.067 17.0451C169.423 16.7993 168.258 15.2989 168.467 13.6534L169.617 4.64112Z"
                fill="#F59E0B" />
            <path
                d="M256.28 47.4393C257.458 46.2717 259.365 46.2783 260.51 47.4795C277.61 65.4148 290.029 87.2792 296.669 111.141C297.114 112.74 296.142 114.377 294.533 114.79L285.723 117.049C284.114 117.46 282.479 116.491 282.03 114.894C276.062 93.6266 264.991 74.1332 249.776 58.1051C248.633 56.9013 248.639 55.0019 249.819 53.8343L256.28 47.4393Z"
                fill="#FACC15" />
            <path
                d="M294.754 116.236C296.367 115.843 297.998 116.829 298.361 118.447C302.241 135.786 303.026 153.674 300.679 171.286C300.46 172.93 298.922 174.055 297.28 173.803L288.289 172.426C286.648 172.173 285.524 170.642 285.741 168.996C287.792 153.341 287.094 137.449 283.68 122.033C283.322 120.414 284.307 118.789 285.92 118.394L294.754 116.236Z"
                fill="#84CC16" />
            <path
                d="M297.251 175.357C298.89 175.623 300.006 177.168 299.706 178.799C297.208 192.395 292.851 205.584 286.759 217.997C286.027 219.485 284.21 220.063 282.734 219.304L274.649 215.142C273.172 214.384 272.596 212.573 273.324 211.083C278.694 200.081 282.551 188.404 284.789 176.371C285.093 174.74 286.635 173.627 288.274 173.894L297.251 175.357Z"
                fill="#16A34A" />
            <text x="-24" y="224" fill="black">300</text>
            <text x="150" y="-8" fill="black">580</text>
            <text x="266" y="40" fill="black">680</text>
            <text x="310" y="120" fill="black">740</text>
            <text x="308" y="180" fill="black">800</text>
            <text x="300" y="224" fill="black">850</text>

            <!-- score Value -->
            <text x="151" y="100" text-anchor="middle" dominant-baseline="middle" font-size="2.4rem" font-weight="700" :fill="scoreColor">
                {{ userScoreData.latest_score }}
            </text>
            <!-- score label -->
            <text x="151" y="140" text-anchor="middle" dominant-baseline="middle" font-size="1.25rem" font-weight="500" :fill="scoreColor">
                {{ scoreLabel }}
            </text>

            <!-- score change -->
            <text x="151" y="180" text-anchor="middle" font-size="0.875rem" fill="gray" class="text-center">
                <tspan class="font-bold" font-size="0.875rem" :fill="scoreChangeClass">{{ userScoreData.prev_score_change_notation}}{{ userScoreData.prev_score_change }}</tspan> updated on {{formattedLastUpdated}}
            </text>

            <svg  v-if="showOutdatedWarning" x="75" y="194" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_327_11178)">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M12.8611 4.49407C12.477 3.83531 11.5259 3.83531 11.1418 4.49408L4.14013 16.5017C3.75255 17.1665 4.23223 18 4.99982 18H19.0031C19.7707 18 20.2504 17.1665 19.8628 16.5017L12.8611 4.49407ZM9.41404 3.48664C10.5698 1.50446 13.4331 1.50445 14.5889 3.48664L21.5905 15.4943C22.7548 17.4911 21.3155 20 19.0031 20H4.99982C2.6874 20 1.24807 17.4911 2.4124 15.4943L9.41404 3.48664ZM12.0015 8.01917C12.5537 8.01917 13.0015 8.46689 13.0015 9.01917V12.0134C13.0015 12.5657 12.5537 13.0134 12.0015 13.0134C11.4492 13.0134 11.0015 12.5657 11.0015 12.0134V9.01917C11.0015 8.46689 11.4492 8.01917 12.0015 8.01917ZM10.7515 15C10.7515 14.3096 11.3111 13.75 12.0015 13.75C12.6918 13.75 13.2515 14.3096 13.2515 15C13.2515 15.6904 12.6918 16.25 12.0015 16.25C11.3111 16.25 10.7515 15.6904 10.7515 15Z" fill="#F59E0B"/>
                </g>
                <defs>
                    <clipPath id="clip0_327_11178">
                        <rect width="24" height="24" fill="white"/>
                    </clipPath>
                </defs>
            </svg>
            <text  v-if="showOutdatedWarning" x="165" y="206" text-anchor="middle" dominant-baseline="middle" font-size="0.875rem" font-weight="500" class="text-center" fill="gray">
                Should be updated
            </text>

            <!-- indicator -->
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" :x="speedometerValuePosition.x" :y="speedometerValuePosition.y">
                <path d="M13.0339 14.0128C14.5029 13.4979 15.1493 11.7801 14.3841 10.4245L9.74462 2.20602C8.70134 0.357922 5.97509 0.568308 5.22771 2.55458L0.960777 13.8946C0.213396 15.8809 2.12473 17.8362 4.12751 17.1343L13.0339 14.0128Z" fill="#1E293B" stroke="white" :transform="`rotate(${speedometerIndicatorRotation} 9 9) scale(0.8)`"></path>
            </svg>

            <!-- this is when value is 575 (mid point) mid x = 151-9=142 -->
<!--            <svg width="24" height="24" viewBox="0 0 24 24" x="142" y="20" fill="none" xmlns="http://www.w3.org/2000/svg">-->
<!--                <path d="M13.0339 14.0128C14.5029 13.4979 15.1493 11.7801 14.3841 10.4245L9.74462 2.20602C8.70134 0.357922 5.97509 0.568308 5.22771 2.55458L0.960777 13.8946C0.213396 15.8809 2.12473 17.8362 4.12751 17.1343L13.0339 14.0128Z" fill="#1E293B" stroke="white" transform="rotate(-110 9 9) scale(0.8)"/>-->
<!--            </svg>-->

<!--            &lt;!&ndash; this is when value is 300 &ndash;&gt;-->
<!--            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" x="36" y="203">-->
<!--                <path d="M13.0339 14.0128C14.5029 13.4979 15.1493 11.7801 14.3841 10.4245L9.74462 2.20602C8.70134 0.357922 5.97509 0.568308 5.22771 2.55458L0.960777 13.8946C0.213396 15.8809 2.12473 17.8362 4.12751 17.1343L13.0339 14.0128Z" fill="#1E293B" stroke="white" transform="rotate(-220 9 9) scale(0.8)"></path>-->
<!--            </svg>-->

<!--            &lt;!&ndash; this is when value is 300 &ndash;&gt;-->
<!--            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" x="247" y="203">-->
<!--                <path d="M13.0339 14.0128C14.5029 13.4979 15.1493 11.7801 14.3841 10.4245L9.74462 2.20602C8.70134 0.357922 5.97509 0.568308 5.22771 2.55458L0.960777 13.8946C0.213396 15.8809 2.12473 17.8362 4.12751 17.1343L13.0339 14.0128Z" fill="#1E293B" stroke="white" transform="rotate(20 9 9) scale(0.8)"></path>-->
<!--            </svg>-->



        </svg>


        <!--
        <ul class="donut-chart">
            <li
                v-for="(slice, sIndex) in slices"
                :key="'slice=' + sIndex"
                :style="
                    'border-color: ' +
                    slice.color +
                    '; z-index: ' +
                    (slices.length - sIndex) +
                    '; animation-name: rotate' +
                    (sIndex + 1)
                "
            >
                <span>{{ slice.score }}</span>
            </li>
            <div
                class="donut-speedometer"
                :style="'transform: rotate(' + speedometerRotation + 'deg)'"
            >
                <div class="sr-only">{{ userScoreData.latest_score }}</div>
            </div>
        </ul>
        -->
    </div>
</template>
<script>
import { mapState, mapActions } from "pinia";
import { useCreditScoreStore } from "@/store/creditscore";
import CountUp from "vue-countup-v3";

export default {
    props: {
        latestScore: {
            type: Number,
            default: 0,
        },
    },
    components: {
        CountUp,
    },
    data: () => ({
        slices: [
            { score: "580", color: "#EF4444" },
            { score: "680", color: "#F59E0B" },
            { score: "740", color: "#FACC15" },
            { score: "800", color: "#84CC16" },
            { score: "850", color: "#16A34A" },
        ],
    }),
    computed: {
        ...mapState(useCreditScoreStore, [
            "loadingUserCreditScore",
            "userScoreData",
        ]),
        scoreLabel() {
            const score = this.userScoreData.latest_score;
            if (score < 580) {
                return "Poor";
            } else if (score >= 580 && score < 680) {
                return "Fair";
            } else if (score >= 680 && score < 740) {
                return "Good";
            } else if (score >= 740 && score < 800) {
                return "Very Good";
            } else if (score >= 800) {
                return "Excellent";
            }
        },
        scoreColor() {
            const score = this.userScoreData.latest_score;
            if (score < 580) {
                return "#EF4444";
            } else if (score >= 580 && score < 680) {
                return "#F59E0B";
            } else if (score >= 680 && score < 740) {
                return "#FACC15";
            } else if (score >= 740 && score < 800) {
                return "#84CC16";
            } else if (score >= 800) {
                return "#16A34A";
            }
        },
        scoreSpeedPercent() {
            return Math.ceil(
                ((this.userScoreData.latest_score - 300) / (850 - 300)) * 100
            );
        },
        speedometerRotation() {
            let deg = (this.scoreSpeedPercent * 180) / 100;
            return Math.ceil(deg + 1);
        },
        speedometerValuePosition() {
            let value = this.userScoreData.latest_score;
            // center point is 142, 142, radius is 122
            // min value is 300, max value is 850
            // for 300, position is approx x="36" y="203"
            // for 575, position is approx x="142" y="20"
            // for 850, position is approx x="247" y="203"
            // calculate position based on score
            // Center of the circle
            const centerX = 142;
            const centerY = 142;
            // Radius of the circle
            const radius = 122;
            // Angles for minimum and maximum values
            const minAngle = -30;
            const maxAngle = 210;
            // Minimum and maximum values
            const minValue = 300;
            const maxValue = 850;

            // Clamp the value within the range
            if (value < minValue) value = minValue;
            if (value > maxValue) value = maxValue;

            // Calculate the angle based on the value
            let angle = ((value - minValue) / (maxValue - minValue)) * (maxAngle - minAngle) + minAngle;
            // Add 180 degrees to move opposite
            angle += 180;

            // Convert the angle to radians
            const radians = (angle * Math.PI) / 180;

            // Calculate the x, y position
            const x = centerX + radius * Math.cos(radians);
            const y = centerY + radius * Math.sin(radians);

            return { x, y };
        },
        speedometerIndicatorRotation() {
            const value = this.userScoreData.latest_score;
            /*
            min values is 300 it rotation is -220 deg
            mid value is 575 it rotation is -110 deg
            max value is 850 it rotation is 20 deg
            if value is less than 300 then rotation is -220
            if value is more than 850 then rotation is 20
            rotation is on clockwise
             */
            let minAngle = -230;
            let maxAngle = 10;
            if (value < 300) {
                return minAngle;
            } else if (value > 850) {
                return maxAngle;
            } else {
                const step = (maxAngle - minAngle) / (850 - 300);
                return minAngle + (value - 300) * step;
            }
        },
        formattedLastUpdated() {
            if (!this.userScoreData?.last_updated) {
                return 'N/A';
            }
            const parts = this.userScoreData.last_updated.split('/');
            let date;
            if (parseInt(parts[0], 10) > 12) {
                // Assume DD/MM/YYYY
                date = new Date(`${parts[2]}-${parts[1]}-${parts[0]}T12:00:00`);
            } else {
                // Assume MM/DD/YYYY
                date = new Date(`${parts[2]}-${parts[0]}-${parts[1]}T12:00:00`);
            }
            const options = { month: 'short', day: 'numeric' };
            return date.toLocaleDateString('en-US', options);
        },
        scoreChangeClass() {
            return this.userScoreData.prev_score_change_notation === '+'
                ? '#22c55e' // Hex for green
                : '#f87171'; // Hex for red
        },
        showOutdatedWarning() {
            return this.userScoreData?.last_updated_days > 60;
        }
    },
    methods: {
        ...mapActions(useCreditScoreStore, ["openCreditScoreModal"]),
    },
    mounted() {
        this.$emit('update:showOutdatedWarning', this.showOutdatedWarning);
    },
};
</script>
<style lang="scss">
.latest-score {
    position: absolute;
    bottom: 95px;
    left: 50%;
    transform: translateX(-50%);
    text-align: center;
    font-size: 2.5rem;
    font-weight: 700;
    line-height: 1.00;
    color: #00b2de;
    z-index: 35;
    small {
        color: #333;
        font-size: 1.25rem;
    }
}

.donut-chart {
    position: relative;
    width: 330px;
    height: 165px;
    overflow: hidden;
    margin: 0 auto;
}

.donut-speedometer {
    width: 155px;
    height: 3px;
    border-radius: 4px;
    position: absolute;
    left: 8px;
    bottom: 3px;
    transform-origin: right 10px;
    backface-visibility: hidden;
    z-index: 35;

    &:after {
        display: block;
        content: "";
        border: 1px solid #fff;
        border-radius: 50%;
        width: 10px;
        height: 10px;
        background-color: rgba(255, 255, 255, 0.35);
        position: absolute;
        left: -5px;
        top: -1px;
    }
}

.donut-chart li {
    position: absolute;
    top: 100%;
    left: 0;
    width: inherit;
    height: inherit;
    border: 25px solid;
    border-top: none;
    border-bottom-left-radius: 165px;
    border-bottom-right-radius: 165px;
    transform-origin: 50% 0;
    transform-style: preserve-3d;
    backface-visibility: hidden;
    animation-fill-mode: forwards;
    animation-duration: 0.4s;
    animation-timing-function: linear;
}

.donut-chart li:nth-child(2) {
    animation-delay: 0.4s;
}

.donut-chart li:nth-child(3) {
    animation-delay: 0.8s;
}

.donut-chart li:nth-child(4) {
    animation-delay: 1.2s;
}

.donut-chart li:nth-child(5) {
    animation-delay: 1.6s;
}

.donut-chart li:nth-child(6) {
    animation-delay: 2s;
}

.donut-chart span {
    position: absolute;
    font-size: 0.85rem;
    backface-visibility: hidden;
    animation: fade-in 0.4s linear forwards;
}

.donut-chart li:nth-child(1) span {
    display: none;
    top: 80%;
    left: 47%;
    transform: rotate(-96deg);
}

.donut-chart li:nth-child(2) span {
    top: 45%;
    left: 30px;
    transform: rotate(230deg);
    animation-delay: 0.4s;
    z-index: 100;
}

.donut-chart li:nth-child(3) span {
    top: 22%;
    left: 12px;
    transform: rotate(211deg);
    animation-delay: 0.8s;
}

.donut-chart li:nth-child(4) span {
    top: 20%;
    left: 10px;
    transform: rotate(-170deg);
    animation-delay: 1.2s;
}

.donut-chart li:nth-child(5) span {
    top: 10%;
    left: 12px;
    transform: rotate(-180deg);
    animation-delay: 1.2s;
}

.donut-chart li:nth-child(6) span {
    display: none;
    top: -3;
    left: 8px;
    transform: rotate(-180deg);
    animation-delay: 1.2s;
}

@keyframes rotate1 {
    100% {
        transform: rotate(94deg);
        /**
     * 12% => 21.6deg
     */
    }
}

@keyframes rotate2 {
    0% {
        transform: rotate(100deg);
    }
    100% {
        transform: rotate(130deg);
        /**
     * 32% => 57.6deg
     * 57.6 + 21.6 => 79.2deg
     */
    }
}

@keyframes rotate3 {
    0% {
        transform: rotate(110deg);
    }
    100% {
        transform: rotate(150deg);
        /**
     * 34% => 61.2deg
     * 61.2 + 79.2 => 140.4deg
     */
    }
}

@keyframes rotate4 {
    0% {
        transform: rotate(140.4deg);
    }
    100% {
        transform: rotate(168deg);
        /**
     * 22% => 39.6deg
     * 140.4 + 39.6 => 180deg
     */
    }
}

@keyframes rotate5 {
    0% {
        transform: rotate(160deg);
    }
    100% {
        transform: rotate(180deg);
        /**
     * 22% => 39.6deg
     * 140.4 + 39.6 => 180deg
     */
    }
}

@keyframes rotate6 {
    0% {
        transform: rotate(180deg);
    }
    100% {
        transform: rotate(180deg);
        /**
     * 22% => 39.6deg
     * 140.4 + 39.6 => 180deg
     */
    }
}

@keyframes fade-in {
    0%,
    90% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
}
</style>
